import { createContext, FunctionalComponent } from 'preact';
import { useContext } from 'preact/hooks';
import { Signal } from '@preact/signals';
import { MoveDirection } from '@accedo/spatial-nav';
import useMouse from '##/hooks/useMouse';

// Shared signal that indicates whether mouse is enabled in the app.
export type MouseContextValue = {
  isMouseEnabled: Signal<boolean>;
  triggerArrowClick: (direction: MoveDirection) => void;
};

const MouseContext = createContext<MouseContextValue | null>(null);

export const MouseProvider: FunctionalComponent = ({ children }) => {
  const mouseValue = useMouse();

  return <MouseContext.Provider value={mouseValue}>{children}</MouseContext.Provider>;
};

export const useMouseState = (): MouseContextValue => {
  const ctx = useContext(MouseContext);

  if (!ctx) {
    throw new Error('useMouse must be used within a MouseProvider');
  }

  return ctx;
};

export default MouseProvider;
